angular
  .module('GlobalControllers')

  .controller('NotIndexCtrl', [
    '$scope',
    '$mdDialog',
    '$http',
    'EXAM',
    '$timeout',
    '$location',
    function($scope, $mdDialog, $http, EXAM, $timeout, $location) {
      $scope.showCpf = false;

      $scope.showCpfInfo = () => {
        $scope.showCpf = true;
        window.Intercom('trackEvent', 'showCPF');
      };

      if (EXAM === 'lerobert') {
        console.log('🔥, should redirect to login page');
        $location.path('/login');
      }

      /*
    $timeout(function () {
      window.sr = ScrollReveal({
        container: document.querySelector('#scrollreveal-container'),
        scale: 1,
        duration: 900
      });

      sr.reveal('.reveal.bottom', { origin: "bottom" }, 250);
      sr.reveal('.reveal.right', { origin: "right" }, 250);
      // sr.reveal('.reveal.left', {origin: "left"});

      // sr.reveal('.features .reveal', {origin: "right"}, 250);
      sr.reveal('#brand .t', { origin: "left" }, 350);

      sr.reveal('.reveal.light', { origin: "bottom", scale: 1 });

    }, 800);
    */

      $scope.showVideoDialog = function(ev) {
        $mdDialog.show({
          templateUrl: '/ng1/www/modules/global/others/html/video.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          parent: angular.element(document.body)
        });
      };
    }
  ])

  .controller('AboutCtrl', [
    '$scope',
    'navbar',
    '$http',
    function($scope, navbar, $http) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');

      $http.get('modules/global/others/data/team.json').success(function(team) {
        $scope.team = team;
      });
    }
  ])

  .controller('AccountCtrl', [
    '$scope',
    'navbar',
    '$http',
    function($scope, navbar, $http) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');
    }
  ])

  .controller('NotSalariesCtrl', [
    '$scope',
    '$location',
    '$mdDialog',
    'exam',
    function($scope, $location, $mdDialog, exam) {
      function showVideoDialog(ev) {
        $mdDialog.show({
          templateUrl: '/ng1/www/modules/global/others/html/video.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          parent: angular.element(document.body)
        });
      }

      $scope.openDialog = function(square, ev) {
        if (square.text === 'Play') {
          showVideoDialog(ev);
        } else {
          $mdDialog.show(
            $mdDialog
              .alert({
                preserveScope: true,
                parent: angular.element(document.body)
              })
              .clickOutsideToClose(true)
              .title(square.text)
              .htmlContent(
                '<div class="s-landing__ctt_dialog">' + square.desc + '</div>'
              )
              .ariaLabel(square.text)
              .ok('Fermer')
              .targetEvent(ev)
          );
        }
      };

      var userType = {
        salaries: {
          seo: {
            title: "Demandeurs d'emplois et salariés - Nathan TOEIC®",
            description:
              "Valorisez votre CV et boostez votre carrière grâce à l’outil d'entraînement innovant Nathan"
          },
          title:
            "Valorisez votre CV et boostez votre carrière<br>grâce à l’outil d'entraînement innovant Nathan<br> pour réussir le TOEIC®",
          ariane: 'Salariés, demandeurs d’emploi',
          squares: [
            {
              colorClass: 'green',
              text: 'TOEIC®, la première certification en langues du CPF',
              desc:
                'Plus de 5 millions de candidats passent le TOEIC®  chaque année dans le monde pour certifier leur niveau d’anglais et se démarquer auprès des recruteurs, pourquoi pas vous ? \
            Grâce à votre Compte Personnel de Formation (CPF), obtenez  le financement de votre TOEIC® et donnez un nouvel élan à votre carrière ! Plus d’infos sur http://www.moncompteformation.gouv.fr'
            },
            {
              colorClass: 'black',
              text: 'Play'
            },
            {
              colorClass: 'light-blue',
              text: 'Entraînez-vous à votre rythme',
              desc:
                'Gagnez en temps et en efficacité et augmentez votre concentration et votre rapidité grâce à la méthode Boost Your Focus, un parcours d’entraînement fractionné. '
            },
            {
              colorClass: 'blue',
              text: 'Optimisez votre score',
              desc:
                'Évaluez-vous grâce au test de niveau qui vous est proposé. \
            Définissez le temps d’entraînement dont vous disposez ainsi que l’objectif de score visé.\
            Optimisez ce score grâce à l’adaptive learning qui cible automatiquement vos difficultés et vos points d’amélioration. '
            }
          ]
        },
        'organismes-de-formation': {
          seo: {
            title: 'Écoles et entreprises - Nathan TOEIC®',
            description:
              'Une solution digitale innovante pour optimiser et valoriser vos parcours d’enseignement online et optimiser les stratégies d’apprentissage de vos apprenants'
          },
          title:
            'Une solution digitale innovante pour optimiser et<br>valoriser vos parcours d’enseignement online et optimiser les stratégies<br>d’apprentissage de vos apprenants',
          ariane: 'Écoles, organismes de formation, entreprises',
          squares: [
            {
              colorClass: 'green',
              text: 'La plateforme pour obtenir le meilleur score au TOEIC®',
              desc:
                'Grâce à l’adaptive learning, la plateforme Nathan TOEIC® cible automatiquement les difficultés et les points d’amélioration de vos apprenants. Elle permet ainsi à chacun de s’entraîner de façon personnalisée et de gagner en temps et en efficacité.'
            },
            {
              colorClass: 'black',
              text: 'Play'
            },
            {
              colorClass: 'light-blue',
              text:
                'Un outil digital efficace et des ressources pédagogiques de qualité',
              desc:
                'Nathan TOEIC® est une solution online complète d’entraînement au test. Conçue par des auteurs spécialistes et ciblant les difficultés des francophones, elle permet à vos apprenants de s’entraîner à leur rythme et selon leur disponibilité, et de réussir le jour J !'
            },
            {
              colorClass: 'blue',
              text: 'Une solution au service des formateurs et des apprenants',
              desc:
                'La plateforme Nathan TOEIC® est l’outil digital idéal pour vos parcours d’apprentissage en blended learning. Simple d’utilisation pour vos apprenants, elle offre également une grande souplesse et de nombreuses fonctionnalités à vos formateurs. Contactez-nous ! Notre équipe Nathan TOEIC® est là pour vous accompagner dans la mise en place de votre projet numérique.'
            }
          ]
        },
        etudiants: {
          seo: {
            title: `Étudiants - Nathan ${exam.examData.displayName.text}®`,
            description: `Réussissez le ${exam.examData.displayName.text}® et optimisez votre temps d’entraînement grâce à nos offres adaptées et à un parcours d’apprentissage personnalisé`
          },
          title: `Réussissez le ${exam.examData.displayName.text}® et optimisez votre temps d’entraînement<br>grâce à nos offres adaptées et<br>à un parcours d’apprentissage personnalisé`,
          ariane: 'Étudiants',
          squares: [
            {
              colorClass: 'green',
              text: 'Optimisez votre score',
              desc:
                'Évaluez-vous grâce au test de niveau qui vous est proposé. Définissez le temps d’entraînement dont vous disposez ainsi que l’objectif de score visé. Optimisez ce score grâce à l’adaptive learning qui cible automatiquement vos difficultés et vos points d’amélioration. '
            },
            /*
          {
            colorClass: 'black',
            text: 'Play'
          },
          */
            {
              colorClass: 'light-blue',
              text: 'Entraînez-vous efficacement',
              desc:
                'Gagnez en temps et en efficacité et augmentez votre concentration et votre rapidité grâce à la méthode Boost Your Focus, un parcours d’entraînement fractionné. '
            },
            {
              colorClass: 'blue',
              text: 'Réussissez le jour J !',
              desc: `Entraînez-vous dans les conditions réelles de l’examen grâce à ${
                exam.examData.numberOfExams
              } ${exam.examData.displayName.text}® blancs corrigés (${exam
                .examData.numberOfExams *
                exam.examData
                  .numberOfQuestionsPerExam} questions), conformes au test officiel, pour réussir le jour J !`
            }
          ]
        }
      };

      $scope.type = $location.path().replace('/', '');
      $scope.data = userType[$scope.type];
    }
  ])

  .controller('OffersCtrl', [
    '$scope',
    function($scope) {
      $scope.features = [
        {
          title: 'Ressources'
        },
        {
          title: 'Personnalisation'
        },
        {
          title: 'Simulation du test TOEIC®'
        }
      ];

      $scope.item =
        'Quisque velit nisi, pretium ut lacinia in, elementum enim. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Curabitur aliquet quam id dui posuere blandit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere.';
    }
  ])

  .controller('TermsCtrl', [
    '$scope',
    'navbar',
    '$http',
    'EXAM',
    function($scope, navbar, $http, EXAM) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');
      $scope.exam = EXAM;
    }
  ])

  .controller('CgvCtrl', [
    '$scope',
    'navbar',
    'EXAM',
    function($scope, navbar, EXAM) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');
      $scope.exam = EXAM;
    }
  ])

  .controller('LegalsCtrl', [
    '$scope',
    'navbar',
    '$http',
    function($scope, navbar, $http) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');
    }
  ])

  .controller('ContactCtrl', [
    '$scope',
    'navbar',
    '$http',
    '$location',
    '$sce',
    'exam',
    'EXAM',
    function($scope, navbar, $http, $location, $sce, exam, EXAM) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');

      var location = $location.path();
      console.log('location', location);

      if (exam.examData.brandName.toLowerCase() === 'nathan') {
        if (location === '/contact/universite') {
          $scope.url = $sce.trustAsResourceUrl(
            'https://contact-toeic.nathan.fr/universite.html'
          );
        } else if (location === '/contact/organisme-formation') {
          $scope.url = $sce.trustAsResourceUrl(
            'https://contact-toeic.nathan.fr/organisme-formation.html'
          );
        } else if (location === '/contact/entreprise') {
          $scope.url = $sce.trustAsResourceUrl(
            'https://contact-toeic.nathan.fr/entreprise.html'
          );
        } else {
          $scope.url = $sce.trustAsResourceUrl(
            'https://contact-toeic.nathan.fr/'
          );
        }
      } else if (EXAM === 'lerobert') {
        $scope.email = 'niskritskaia@sejer.fr';
      } else {
        $scope.url = $sce.trustAsResourceUrl(
          'https://contact-toeic.nathan.fr/'
        );
      }
    }
  ])

  .controller('HelpCtrl', [
    '$scope',
    '$mdDialog',
    '$location',
    'EXAM',
    function($scope, $mdDialog, $location, EXAM) {
      $scope.exam = EXAM;
      console.log('🙂', EXAM);
      $scope.openHelp = function(ev) {
        $mdDialog.show({
          controller: [
            '$scope',
            '$mdDialog',
            function($scope, $mdDialog) {
              $scope.hide = function() {
                $mdDialog.hide();
              };
              $scope.cancel = function() {
                $mdDialog.cancel();
              };
              $scope.swipe = function(side) {
                if (side === 'right' && $scope.selectedIndex !== 0) {
                  $scope.selectedIndex--;
                }
                if (side === 'left' && $scope.selectedIndex !== 4) {
                  $scope.selectedIndex++;
                }
              };
              var url = $location.url();
              if (url === '/exam') $scope.selectedIndex = 1;
              else if (url === '/training') $scope.selectedIndex = 2;
              else if (url === '/lesson') $scope.selectedIndex = 3;
              else if (url === '/lexicon') $scope.selectedIndex = 4;
              else $scope.selectedIndex = 0;
            }
          ],
          templateUrl: '/ng1/www/modules/global/others/html/help.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          parent: angular.element(document.body)
        });
      };
    }
  ])

  .controller('TipsCtrl', [
    '$scope',
    '$mdDialog',
    '$location',
    function($scope, $mdDialog, $location) {
      $scope.openTips = function(ev, part) {
        $mdDialog.show({
          controller: [
            '$scope',
            '$mdDialog',
            function($scope, $mdDialog) {
              $scope.hide = function() {
                $mdDialog.hide();
              };
              $scope.cancel = function() {
                $mdDialog.cancel();
              };
              $scope.swipe = function(side) {
                if (side === 'right' && $scope.selectedIndex !== 0) {
                  $scope.selectedIndex--;
                }
                if (side === 'left' && $scope.selectedIndex !== 6) {
                  $scope.selectedIndex++;
                }
              };
              var url = $location.url();
              if (url === '/training/on?part=1' || part === 1)
                $scope.selectedIndex = 0;
              else if (url === '/training/on?part=2' || part === 2)
                $scope.selectedIndex = 1;
              else if (url === '/training/on?part=3' || part === 3)
                $scope.selectedIndex = 2;
              else if (url === '/training/on?part=4' || part === 4)
                $scope.selectedIndex = 3;
              else if (url === '/training/on?part=5' || part === 5)
                $scope.selectedIndex = 4;
              else if (url === '/training/on?part=6' || part === 6)
                $scope.selectedIndex = 5;
              else if (url === '/training/on?part=7' || part === 7)
                $scope.selectedIndex = 6;
              else $scope.selectedIndex = 0;
            }
          ],
          templateUrl:
            '/ng1/www/modules/exam/toeic/components/dialog-tips.html',
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          parent: angular.element(document.body)
        });
      };
    }
  ])

  .component('contentWrapper', {
    template: '<ng-transclude></ng-transclude>',
    transclude: true
  })

  .component('appPricing', {
    templateUrl: '/ng1/www/modules/global/others/html/pricing.component.html',
    controller: [
      'pricing',
      '$location',
      'exam',
      function(pricing, $location, exam) {
        this.examName = exam.examData.displayName.text;

        this.prices = pricing.getPrices();
        this.type =
          $location.path() === '/organismes-de-formation' ? 'of' : null;
        this.isIndex = $location.path() === '/';
        console.log('yolo', $location.path() === '/');
        this.selectedPrice = 1;

        var self = this;
        this.onSelectedPriceChange = function() {
          console.log('yolo');
          if (self.selectedPrice === 1) {
            self.planValue = 31;
            self.price = 59;
          } else if (self.selectedPrice === 0) {
            self.planValue = 15;
            self.price = 39;
          } else if (self.selectedPrice === 2) {
            self.planValue = 92;
            self.price = 79;
          }
        };
        this.onSelectedPriceChange();

        this.pricesItemsOf = [
          'Tableau de bord',
          'Suivi de la progression',
          '1 200 questions TOEIC® Listening & Reading ',
          'Entraînement personnalisé',
          'Entraînement par notion',
          'Entraînement fractionné',
          'Corrigés détaillés',
          '9 tests blancs',
          'Cours de grammaire / conjugaison / vocabulaire',
          'Tips sur les 7 parties du test',
          'Glossaire personnalisable'
        ];

        this.pricesItemsOf2 = [
          'Gestion de groupes d’apprenants',
          'Suivi de la progression par groupe et par apprenant',
          'Suivi du temps passé',
          'Planification de tests blancs',
          'Correction automatique des tests blancs'
        ];

        this.pricesItemsOfFinancement = [
          `4 mois d\'accès à la plateforme Nathan ${this.examName}®`,
          'Coaching à distance',
          'Formations en anglais à distance ou en face à face dans toute la France',
          `Passage de la certification ${this.examName}`
        ];

        this.pricesItems = [
          [
            `${exam.examData.numberOfExams *
              exam.examData.numberOfQuestionsPerExam} questions ${
              this.examName
            }`,
            'Entraînement personnalisé',
            'Entraînement par notion'
          ],
          [
            'Tableau de bord',
            'Suivi de la progression',
            `${exam.examData.numberOfExams *
              exam.examData.numberOfQuestionsPerExam} questions`,
            'Entraînement personnalisé',
            'Entraînement par notion',
            'Corrigés détaillés',
            `${exam.examData.numberOfExams} tests blancs`,
            'Cours de grammaire/vocabulaire',
            exam.examData.name === 'toeic'
              ? 'Tips sur les 7 parties du test'
              : null,
            'Glossaire personnalisable'
          ].filter(r => !!r),
          [
            'Gestion de groupes d’apprenants',
            'Suivi de la progression par groupe et par apprenant',
            'Planification de tests blancs',
            'Correction automatique des tests blancs'
          ]
        ];
      }
    ]
  })

  .component('appWhereYouWant', {
    templateUrl:
      '/ng1/www/modules/global/others/html/whereyouwant.component.html',
    bindings: {
      userType: '<'
    },
    controller: [
      'exam',
      function(exam) {
        this.examData = exam.examData;

        let data = {
          'organismes-de-formation': {
            title: 'Un outil pratique,<br>fiable et intuitif',
            p:
              'Offrez à vos apprenants un entraînement à la carte sur ordinateur, smartphone ou tablette, 24h/24 et 7J/7.',
            btn: 'Commencez'
          },
          etudiants: {
            title: 'Entraînez-vous<br>quand vous voulez,<br>où vous voulez',
            p:
              'Connectez-vous sur votre ordinateur, votre smartphone ou votre tablette.',
            btn: 'Abonnez-vous'
          },
          salaries: {
            title: 'Entraînez-vous<br>quand vous voulez,<br>où vous voulez',
            p:
              'Connectez-vous sur votre ordinateur, votre smartphone ou votre tablette.',
            btn: 'Abonnez-vous'
          }
        };

        this.$onInit = function() {
          var userType = this.userType ? this.userType : 'etudiants';
          this.data = data[userType];
        };
      }
    ]
  })

  .component('appAdaptive', {
    templateUrl: '/ng1/www/modules/global/others/html/adaptive.component.html',
    controller: function() {
      this.adaptives = [
        {
          title: 'Sciences cognitives',
          text:
            "Nous définissons à partir de vos réponses et de votre profil pédagogique une session d'entrainement adapté.",
          icon: '/ng1/www/img/new/index/sciences_cognitives.png'
        },
        {
          title: 'Machine learning',
          text:
            "Notre algorithme s'appuie sur l'ensemble des parcours d'apprentissage de nos apprenants pour vous faire profiter de la meilleure experience utilisateur possible.",
          icon: '/ng1/www/img/new/index/machine_learning.png'
        },
        {
          title: 'Optimisation',
          text:
            'Votre temps est précieux ! Nous mettons à votre disposition tout notre savoir faire pour que vous réussissiez en un temps record.',
          icon: '/ng1/www/img/new/index/big_data.png'
        }
      ];
    }
  })

  .component('appBrand', {
    templateUrl: '/ng1/www/modules/global/others/html/brand.component.html',
    bindings: {
      userType: '<'
    },
    controller: [
      'exam',
      function(exam) {
        var data = {
          'organismes-de-formation': [
            {
              title: "S'évaluer",
              text:
                'Evaluez dès aujourd’hui le score initial de vos apprenants pour fixer avec eux leur objectif.'
            },
            {
              title: "S'entraîner",
              text:
                "Proposez à vos apprenants 3 modes d'entraînement pour une progression efficace : personnalisé, fractionné  et par notion."
            },
            {
              title: 'Optimiser',
              text:
                'Offrez à vos apprenants un outil conçu pour optimiser leur temps de préparation en ciblant automatiquement leurs difficultés.'
            },
            {
              title: 'Réussir',
              text:
                'Mettez vos apprenants en situation d’examen pour réussir le jour J grâce à 9 tests blancs. '
            }
          ],
          etudiants: [
            {
              title: "S'évaluer",
              text:
                'Evaluez dès aujourd’hui votre score initial pour atteindre votre objectif.'
            },
            {
              title: "S'entraîner",
              text:
                "Progressez rapidement grâce à 3 modes d'entraînement : personnalisé, fractionné et par notion."
            },
            {
              title: 'Optimiser',
              text:
                'Optimisez votre score et votre temps de préparation en ciblant vos difficultés.'
            },
            {
              title: 'Réussir',
              text: `Atteignez votre objectif  en vous mettant en situation d’examen grâce à ${exam.examData.numberOfExams} tests blancs.`
            }
          ],
          salaries: [
            {
              title: "S'évaluer",
              text:
                'Evaluez dès aujourd’hui votre score initial pour atteindre votre objectif.'
            },
            {
              title: "S'entraîner",
              text:
                "Progressez rapidement  grâce à 3 modes d'entraînement : personnalisé, fractionné  et par notion."
            },
            {
              title: 'Optimiser',
              text:
                'Optimisez votre score et votre temps de préparation en ciblant vos difficultés.'
            },
            {
              title: 'Réussir',
              text:
                'Atteignez votre objectif  en vous mettant en situation d’examen grâce à 9 tests blancs.'
            }
          ]
        };

        this.$onInit = function() {
          var userType = this.userType ? this.userType : 'etudiants';
          this.features = data[userType];
        };
      }
    ]
  })

  .component('appAuthors', {
    templateUrl: '/ng1/www/modules/global/others/html/authors.component.html',
    controller: [
      'exam',
      'EXAM',
      function(exam, EXAM) {
        this.examData = exam.examData;

        this.authors = [
          {
            name: 'Serena Murdoch Stern',
            description:
              'anglophone, est enseignante dans de grandes écoles et universités parisiennes (GEM, EEMI, ESSCA, ESTBA, EPHE), et formatrice d’anglais en entreprise (spécialisée dans l’anglais des affaires). Administrateur habilité par ETS et auteur de nombreuses méthodes de langues à succès, Serena Murdoch Stern vous fait bénéficier de son expérience acquise auprès des étudiants et candidats individuels passant les TOEIC®, TOEFL®, BULATS et IELTS.',
            img: 'murdoch_stern.png'
          },
          {
            name: 'Philippe Hermelin',
            description:
              'est le cofondateur de la société Schwa, organisme de formation professionnelle créé en 2007. Passionné de pédagogie, il enseigne l’anglais en entreprise et en école de commerce et prépare régulièrement ses étudiants au test TOEIC à travers l’élaboration de parcours pédagogiques personnalisés.',
            img: 'p_hermelin.jpg'
          },
          {
            name: 'William Merry',
            description:
              'professeur, a plus de 30 ans d’expérience de l’enseignement en formation continue et au sein de grandes écoles parisiennes. Il travaille aussi pour les examens de la Chambre de commerce franco-britannique.',
            img: 'william_merry.jpg'
          },
          {
            name: 'David W.S. Higgins',
            description:
              'PhD, est spécialisé dans l’enseignement de l’anglais en contexte professionnel. Il a enseigné en Allemagne et travaille aujourd’hui en France. Il est également traducteur d’ouvrages en anglais.',
            img: 'david_higgins.jpg'
          }
        ];

        if (EXAM === 'linguaskill') {
          this.authors = [this.authors[0], this.authors[3]];
        }
      }
    ]
  })

  .component('appTrainings', {
    templateUrl: '/ng1/www/modules/global/others/html/trainings.component.html',
    controller: [
      'exam',
      function(exam) {
        this.examData = exam.examData;

        this.title = `Profitez de 3 modes d'entraînements,<br>
      de ${exam.examData.numberOfExams} examens blancs, de fiches de cours et de tips`;

        this.trainings = [
          {
            name: 'Personnalisé',
            content: `Fini le temps perdu, vos faiblesses sont identifiées pour vous entraîner de manière vraiment efficace.`
          },
          {
            name: 'Fractionné',
            content:
              'Apprenez petit à petit à enchaîner les épreuves, afin d’augmenter votre niveau de concentration et finir l’examen dans les temps.'
          },
          {
            name: 'Par notion',
            content:
              'Identifiez les cours de grammaire, de conjugaison et de vocabulaire qui vous posent problème et profitez d’un entraînement ciblé.'
          }
        ];
      }
    ]
  });
